import Workspaces from "./views/Workspaces.vue";
import WorkspaceEditor from "./views/WorkspaceEditor.vue";

const moduleRoutes = [
	{
		path: "/:domainId/template/:dataspaceId/template/workspaces",
		name: "Workspaces",
		component: Workspaces,
	},
	{
		path: "/:domainId/template/:dataspaceId/template/:workspaceId",
		name: "Workspace Editor",
		component: WorkspaceEditor,
	},
];

export default moduleRoutes;
